// src/pages/Papers.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import '../styles/Paper.css';
import { FaBell, FaUserCircle } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';

import scienceImg from '../assets/image 6.png';
import mathsImg from '../assets/maths.png';
import GujaratiIcon from '../assets/GujaratiIcon.png';
import EnglishIcon from '../assets/EnglishIcon.png';
import Biology from '../assets/biology.png';
import HindiIcon from '../assets/HindiIcon.png';
import Chemistry from '../assets/laboratory.png';
import SocialScienceIcon from '../assets/SocialScienceIcon.png';
import Physics from '../assets/atom.png';

import regular from '../assets/ragular.png';
import expert from '../assets/expert.png';

const CustomDropdown = ({ label, options, selected, setSelected }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, []);

  return (
    <div className="info-box" ref={ref}>
      <p className="label">{label}</p>
      <div className="custom-dropdown" onClick={() => setOpen(!open)}>
        <div className="selected">{selected?.name || `Select ${label}`}</div>
        {open && (
          <div className="options">
            {options.map((opt) => (
              <div
                key={opt.id}
                className="option"
                onClick={() => {
                  setSelected(opt);
                  setOpen(false);
                  // Save selected in localStorage
                  if (label.toLowerCase() === 'board') localStorage.setItem('selectedBoard', JSON.stringify(opt));
                  if (label.toLowerCase() === 'grade') localStorage.setItem('selectedGrade', JSON.stringify(opt));
                }}
              >
                {opt.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Papers = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState('papers');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [boards, setBoards] = useState([]);
  const [grades, setGrades] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [selectedBoard, setSelectedBoard] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);

  // Load previously selected IDs from localStorage
  useEffect(() => {
    const storedBoard = JSON.parse(localStorage.getItem('selectedBoard') || 'null');
    const storedGrade = JSON.parse(localStorage.getItem('selectedGrade') || 'null');
    const storedSubject = JSON.parse(localStorage.getItem('selectedSubject') || 'null');

    if (storedBoard) setSelectedBoard(storedBoard);
    if (storedGrade) setSelectedGrade(storedGrade);
    if (storedSubject) setSelectedSubject(storedSubject);
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => setShowDropdown((prev) => !prev);
  const dropdownRef = useRef(null);
  const [dashboardData, setDashboardData] = useState({
    totalBoard: 0,
    totalGrade: 0,
    totalSubjects: 0,
    totalPapers: 0,
    totalQuestions: 0,
  });
  const [user, setUser] = useState({
    id: null,
    name: '',
    email: '',
    password: '',
  });

  // Fetch dashboard & user data
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://digital.tifleducation.com/admin/public/api/getDashboard", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setDashboardData({
            totalBoard: res.data.totalBoards || 0,
            totalGrade: res.data.totalGrades || 0,
            totalSubjects: res.data.totalSubjects || 0,
            totalPapers: res.data.totalPapers || 0,
            totalQuestions: res.data.totalQuestions || 0,
          });
          if (res.data.user) {
            setUser({
              id: res.data.user.id,
              name: res.data.user.name || '',
              email: res.data.user.email || '',
              password: '', // empty for editing
            });
          }
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error.response?.data || error);
      }
    };

    fetchDashboardData();
  }, []);
  // Handle save changes
  const handleSaveProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        "https://digital.tifleducation.com/admin/public/api/update-profile",
        {
          name: user.name,
          password: user.password,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Profile updated successfully!");

      setIsModalOpen(false);
      setUser({ ...user, password: '' }); // reset password field
    } catch (error) {
      console.error("Error updating profile:", error.response?.data || error);

      toast.error("Failed to update profile");

    }
  };
  // Fetch boards
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios
      .get('https://digital.tifleducation.com/admin/public/api/getBoards', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setBoards(res.data.data || []))
      .catch((err) => console.error(err));
  }, []);

  // Fetch grades when board changes
  useEffect(() => {
    if (!selectedBoard) return;
    const token = localStorage.getItem('token');
    axios
      .get(`https://digital.tifleducation.com/admin/public/api/getGrades?board_id=${selectedBoard.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setGrades(res.data.data || []);
        // If stored grade belongs to this board, keep it; else reset
        const storedGrade = JSON.parse(localStorage.getItem('selectedGrade') || 'null');
        if (storedGrade && res.data.data.some(g => g.id === storedGrade.id)) {
          setSelectedGrade(storedGrade);
        } else {
          setSelectedGrade(null);
          setSubjects([]);
          setSelectedSubject(null);
          localStorage.removeItem('selectedGrade');
          localStorage.removeItem('selectedSubject');
        }
      })
      .catch((err) => console.error(err));
  }, [selectedBoard]);

  // Fetch subjects when grade changes
  useEffect(() => {
    if (!selectedBoard || !selectedGrade) return;
    const token = localStorage.getItem('token');
    axios
      .get(
        `https://digital.tifleducation.com/admin/public/api/getSubjects?board_id=${selectedBoard.id}&grade_id=${selectedGrade.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setSubjects(res.data.data || []);
        // restore stored subject if valid
        const storedSubject = JSON.parse(localStorage.getItem('selectedSubject') || 'null');
        if (storedSubject && res.data.data.some(s => s.id === storedSubject.id)) {
          setSelectedSubject(storedSubject);
        } else {
          setSelectedSubject(null);
          localStorage.removeItem('selectedSubject');
        }
      })
      .catch((err) => console.error(err));
  }, [selectedGrade, selectedBoard]);

  const handlePaperTypeClick = (type) => {
    if (!selectedBoard || !selectedGrade || !selectedSubject) {
      toast.error('Please select Board, Grade and Subject first.');
      return;
    }
    // Save subject in localStorage
    localStorage.setItem('selectedSubject', JSON.stringify(selectedSubject));

    const routeState = {
      boardId: selectedBoard.id,
      gradeId: selectedGrade.id,
      subjectId: selectedSubject.id,
    };
    if (type === 'regular') navigate('/selectregularpaper', { state: routeState });
    else navigate('/expertpaper', { state: routeState });
  };

  const getSubjectImage = (name) => {
    if (!name) return scienceImg;
    const lower = name.toLowerCase();
    if (lower.includes('mathematics')) return mathsImg;
    if (lower.includes('gujarati')) return GujaratiIcon;
    if (lower.includes('english')) return EnglishIcon;
    if (lower.includes('hindi')) return HindiIcon;
    if (lower.includes('biology')) return Biology;
    if (lower.includes('social')) return SocialScienceIcon;
    if (lower.includes('chemistry')) return Chemistry;
    if (lower.includes('physics')) return Physics;
    return scienceImg;
  };

  return (
    <div className="dashboard-container">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <main className="main-content">
        <div className="papers-header">
          <div className="papers-welcome-text">Papers</div>
          <div className="header-icons" ref={dropdownRef}>
            <FaBell className="icon" />
            <div className="user-dropdown-wrapper">
              <FaUserCircle className="icon" onClick={toggleDropdown} />
              {showDropdown && (
                <div className="user-dropdown">
                  <div className='edituser' onClick={() => setIsModalOpen(true)}>
                    <FaUserCircle className="ditusericon" />
                    <span>Edit Profile</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="subject">
          <h3>Select Options</h3>
        </div>

        <div className="paper-info-boxes">
          <CustomDropdown
            label="Board"
            options={boards}
            selected={selectedBoard}
            setSelected={setSelectedBoard}
          />
          <CustomDropdown
            label="Grade"
            options={grades}
            selected={selectedGrade}
            setSelected={setSelectedGrade}
          />
        </div>

        {selectedGrade && (
          <>
            <div className="subject">
              <h3>Select Subject</h3>
            </div>
            <div className="subjects-grid">
              {subjects.map((subject) => (
                <div
                  key={subject.id}
                  className={`subject-box ${selectedSubject?.id === subject.id ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedSubject(subject);
                    localStorage.setItem('selectedSubject', JSON.stringify(subject));
                  }}
                >
                  <img src={getSubjectImage(subject.name)} alt={subject.name} />
                  <p>{subject.name}</p>
                </div>
              ))}
            </div>
          </>
        )}

        {selectedSubject && (
          <>
            <div className="selected-subject">
              <h4>{selectedSubject.name}</h4>
            </div>

            <div className="paper-type-section">
              <div className="paper-card" onClick={() => handlePaperTypeClick('regular')}>
                <div className="paper-text">
                  <h4>Regular Paper</h4>
                  <p>Select Question Of Your Choice</p>
                </div>
                <img src={regular} alt="Regular Paper" />
              </div>

              <div className="paper-card" onClick={() => handlePaperTypeClick('expert')}>
                <div className="paper-text">
                  <h4>Expert Mode</h4>
                  <p>Select From Already Best Papers</p>
                </div>
                <img src={expert} alt="Expert Paper" />
              </div>
            </div>
          </>
        )}
      </main>
      {/* Profile Edit Modal */}
      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <button style={modalStyles.closeBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
            <div style={modalStyles.userIcon}><FaUserCircle /></div>
            <div style={modalStyles.formGroup}>
              <label>Username</label>
              <input type="text" value={user.name} onChange={e => setUser({ ...user, name: e.target.value })} style={modalStyles.input} />
            </div>
            <div style={modalStyles.formGroup}>
              <label>Email</label>
              <input type="email" value={user.email} disabled style={{ ...modalStyles.input, background: '#f0f0f0', color: '#888' }} />
            </div>
            <div style={modalStyles.formGroup}>
              <label>Password</label>
              <input type="password" value={user.password} onChange={e => setUser({ ...user, password: e.target.value })} style={modalStyles.input} />
            </div>
            <div style={{ textAlign: 'right' }}>
              <button style={modalStyles.saveBtn} onClick={handleSaveProfile}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ----- Modal Styles -----
const modalStyles = {
  overlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modal: { background: "#fff", padding: "2rem", borderRadius: "12px", width: "90%", maxWidth: "400px", position: "relative", boxShadow: "0 4px 15px rgba(0,0,0,0.2)" },
  closeBtn: { position: "absolute", top: "10px", right: "15px", background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer" },
  userIcon: { textAlign: "center", fontSize: "4rem", color: "#129255", marginBottom: "1rem" },
  formGroup: { marginBottom: "1rem" },
  input: { width: "100%", padding: "0.5rem 0.8rem", borderRadius: "6px", border: "1px solid #ccc", outline: "none" },
  saveBtn: { background: "#129255", color: "#fff", border: "none", padding: "0.6rem 1.2rem", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }
};

export default Papers;
